<div id="banner-funds-tematicas" class="swiper-background d-lg-flex align-items-center  pt-5 pt-lg-0">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 col-lg-6 col-xl-7 mb-lg-5">
                <div class="img-container mb-3">
                    <img src="/assets/images/funds/myInvestor/FUNDS+MYI.svg" alt="MyInvestor | SEGO Funds"
                        title="MyInvestor | SEGO Funds" class="img-fluid logo-myinvestor">
                </div>
                <h1 class="primary-900 h1-display mb-2">¡<span class="secondary-funds-700">Carteras temáticas</span><br>
                    exclusivas!</h1>
                <div class="d-none d-lg-block">
                    <p class="p-display">
                        Vigiladas por un comité de expertos que se reúne mensualmente.
                    </p>
                    <p class="p-display">
                        Vamos un paso más allá para aprovechar todas las oportunidades<br class="d-none d-xxl-block"> de
                        los mercados a nivel global.
                    </p>
                </div>
                <div class="mt-3 mt-lg-4">
                    <app-btn-link [linkId]="'btn-banner-tematicas'" [linkTitle]="'Más información'"
                        [linkUrl]="'/tematicas'"></app-btn-link>
                </div>
            </div>
        </div>
    </div>
</div>